
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M17.833 2H6.167A4.167 4.167 0 002 6.167v11.666C2 20.134 3.866 22 6.167 22h11.666A4.167 4.167 0 0022 17.833V6.167C22 3.866 20.135 2 17.833 2zM8.667 17.833h-2.5V8.667h2.5v9.166zM7.417 7.61a1.465 1.465 0 01-1.459-1.47c0-.812.654-1.47 1.459-1.47s1.458.658 1.458 1.47c0 .812-.652 1.47-1.458 1.47zm11.25 10.223h-2.5v-4.67c0-2.806-3.334-2.594-3.334 0v4.67h-2.5V8.667h2.5v1.47c1.164-2.155 5.834-2.314 5.834 2.064v5.632z","fill":"#2867B2"}})])
          )
        }
      }
    